<app-scenario-selection [showDefaultScen]="true" [distanceID]="distanceID"  [sectionName]="childName" [section]="childSection"
  (forward)="finishSelection($event)" >
</app-scenario-selection>
